import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { constVoid } from 'fp-ts/function';
import { nanoid } from 'nanoid';
import { createContext, useContext, useEffect, useRef } from 'react';
import { sendBatch, sendData } from './api';
import { EventType } from './types';
import { jsx as _jsx } from "react/jsx-runtime";

var commonParameters = function commonParameters() {
  return {
    referrer: window.document.referrer,
    os: window.navigator.platform
  };
};

var buildName = function buildName(category, name) {
  return "".concat(category, "-").concat(name);
};

export var PageEventsTrackerContext = /*#__PURE__*/createContext({
  startActivity: function startActivity() {
    return constVoid;
  },
  stopActivity: constVoid,
  trackClick: constVoid
});
export var usePageEventsTracker = function usePageEventsTracker() {
  return useContext(PageEventsTrackerContext);
};
export var PageEventsTracker = function PageEventsTracker(_ref) {
  var children = _ref.children;
  var activeTrackers = useRef({});

  var startActivity = function startActivity(category, name, data) {
    var trackerName = buildName(category, name);
    if (activeTrackers.current[trackerName]) return function () {
      return stopActivity(category, name);
    };
    var trackingData = {
      tracker_id: nanoid(),
      event_type: EventType.map.view,
      parameters: _objectSpread(_objectSpread({
        category: category,
        name: name
      }, commonParameters()), data)
    };
    sendData(trackingData);
    activeTrackers.current[trackerName] = trackingData;
    return function () {
      return stopActivity(category, name);
    };
  };

  var stopActivity = function stopActivity(category, name) {
    var trackerName = buildName(category, name);
    var trackingData = activeTrackers.current[trackerName];

    if (trackingData !== undefined) {
      sendData(trackingData);
      delete activeTrackers.current[trackerName];
    }
  };

  var trackClick = function trackClick(elementName, category, pageName) {
    sendData({
      tracker_id: nanoid(),
      event_type: EventType.map.click,
      parameters: _objectSpread({
        name: elementName,
        category: category,
        page_name: pageName
      }, commonParameters())
    });
  };

  useEffect(function () {
    var visibilityChangeListener = function visibilityChangeListener() {
      if (document.visibilityState !== 'hidden') return;
      if (Object.values(activeTrackers.current).length === 0) return;
      sendBatch(Object.values(activeTrackers.current));
    };

    window.document.addEventListener('visibilitychange', visibilityChangeListener);
    return function () {
      return window.document.removeEventListener('visibilitychange', visibilityChangeListener);
    };
  }, []);
  return /*#__PURE__*/_jsx(PageEventsTrackerContext.Provider, {
    value: {
      startActivity: startActivity,
      stopActivity: stopActivity,
      trackClick: trackClick
    },
    "data-element": "unknown",
    "data-component": "PageEventsTracker",
    "data-source-file": "page-events.tracker.tsx",
    children: children
  });
};